export default {"src":"/_next/static/media/usersFill.cd33df91.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};